export default["__VITE_ASSET__CU8wF0B7__","__VITE_ASSET__Aem0R2re__"];